<div class="d-flex justify-content-center" *ngIf="token && email">
    <div class="col-12 col-lg-5">
        <main class="form-signin">
            <form [formGroup]="resetPasswordForm" class="form-signin" (ngSubmit)="resetPassword()" autocomplete="off">
                <div class="text-center mb-4">
                    <h1 class="mb-3 font-weight-normal">
                        Change your password
                    </h1>
                </div>

                <div class="form-floating mb-3">
                    <input formControlName="email" type="text" placeholder="Email" class="form-control">
                    <label for="email">Email</label>
                </div>

                <div class="form-floating mb-3">
                    <input formControlName="newPassword" type="password" placeholder="New Password" class="form-control"
                        [class.is-invalid]="submitted && resetPasswordForm.get('newPassword')?.errors">
                    <label for="newPassword">New Password</label>
                    <span class="text-danger" *ngIf="submitted && resetPasswordForm.get('newPassword')?.hasError('required')">
                        New Password is required
                    </span>
                    <span class="text-danger"
                        *ngIf="submitted && 
                        resetPasswordForm.get('newPassword')?.hasError('minlength') || resetPasswordForm.get('newPassword')?.hasError('maxlength')">
                        New Password must be at least 6, and maximum 15 characters
                    </span>
                </div>

                <div class="form-floatin" *ngIf="errorMessages.length > 0">
                    <identity-validation-messages [errorMessages]="errorMessages"></identity-validation-messages>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="d-grid">
                            <button class="btn btn-block btn-success" type="submit">Change Password</button>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-grid">
                            <button class="btn btn-block btn-danger" type="button" routerLink="/account/login">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </main>
    </div>
</div>